<template>
  <div>
    <br />
    <div class v-if="data.data && data.data.length > 0">
      <a href data-toggle="modal" @click="download()">
        <button class="btn btn-outline-brand m-btn m-btn--outline">
          <i class="fas fa-download"></i> Baixar
        </button>
      </a>
    </div>
    <div class="row mb-3">
      <div class="col-md-6">
        <label for="billing_month"
          >Data da execução de Reajuste de contratos (mm/yyyy) <span class="m--font-danger">*</span></label
        >
        <div class="input-group">
          <input
            id="billing_month"
            type="text"
            ref="billing_month"
            class="form-control m-input"
            placeholder="mm/aaaa"
            v-model="billing_month"
            v-mask="'##/####'"
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="m-portlet m-portlet--tab">
          <div class="m-portlet__body">
            <div class="table-responsive">
              <div class="container-table">
                <table class="table table-striped- table-bordered table-hover table-checkable">
                  <thead>
                    <tr>
                      <td
                        nowrap
                        class="text-center align-middle pointer"
                        width="60"
                        :class="{ 'table-sorted': sortType === 'id' }"
                        @click="sortCall('id')"
                      >
                        ID Contrato
                      </td>
                      <td nowrap class="text-center align-middle" width="60">ID Cliente</td>
                      <td nowrap class="text-center align-middle" width="200">
                        Nome
                      </td>
                      <td nowrap class="text-center align-middle" width="200">Documento</td>
                      <td nowrap class="text-center align-middle" width="100">
                        Produto
                      </td>
                      <td nowrap class="text-center align-middle" width="100">
                        % do Reajuste
                      </td>
                      <td nowrap class="text-center align-middle" width="100">
                        Mês de aniversário
                      </td>
                      <td nowrap class="text-center align-middle" width="100">
                        Serviços antes
                      </td>
                      <td nowrap class="text-center align-middle" width="100">
                        Serviços depois
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <input
                          type="text"
                          class="form-control form-control-sm m-input inputNumberFilter"
                          v-model="filters.contractId"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          class="form-control form-control-sm m-input inputNumberFilter"
                          v-model="filters.customer_id"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          class="form-control form-control-sm m-input inputTextFilter"
                          v-model="filters.name"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          class="form-control form-control-sm m-input"
                          v-model="filters.document"
                        />
                      </td>
                      <td>
                        <SelectProducts
                          :selected="filters.product"
                          @change="setFilter('product', $event)"
                          class="form-control-sm"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          class="form-control form-control-sm m-input inputNumberFilter"
                          v-model="filters.percent"
                        />
                      </td>
                      <td>
                        <select
                          class="form-control form-control-sm m-input"
                          v-model="filters.birthday_month"
                        >
                          <option value="">Todos</option>
                          <option value="1">Janeiro</option>
                          <option value="2">Fevereiro</option>
                          <option value="3">Março</option>
                          <option value="4">Abril</option>
                          <option value="5">Maio</option>
                          <option value="6">Junho</option>
                          <option value="7">Julho</option>
                          <option value="8">Agosto</option>
                          <option value="9">Setembro</option>
                          <option value="10">Outubro</option>
                          <option value="11">Novembro</option>
                          <option value="12">Dezembro</option>
                        </select>
                      </td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr v-for="(contract, id) in data.data" :key="id">
                      <td class="text-center align-middle">{{ contract.contractId }}</td>
                      <td class="text-center align-middle">
                        {{ contract.customerId }}
                      </td>
                      <td class="text-center align-middle">
                        {{ contract.name }}
                      </td>
                      <td class="text-center align-middle">
                        {{ contract.document | cnpj | cpf }}
                      </td>
                      <td class="text-center align-middle">
                        {{ contract.productName }}
                      </td>
                      <td class="text-center align-middle">
                        {{ contract.percent }}
                      </td>
                      <td class="text-center align-middle">
                        {{ contract.birthdayMonth | monthNames }}
                      </td>
                      <td class="text-center align-middle">
                        {{ contract.servicesBefore }}
                      </td>
                      <td class="text-center align-middle">
                        {{ contract.servicesAfter }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div>
              <div class="paginator-info-bottom mt-2">
                <span class="m--font-gray" v-if="data.from"
                  >Exibindo itens de {{ data.from }} a {{ data.to }}, de um total de
                  {{ data.total }}.</span
                >
                <span class="m--font-gray" v-else>Nenhum item a ser exibido.</span>
              </div>
              <div class="paginator-list">
                <nav aria-label="...">
                  <ul class="pagination pagination-md">
                    <li class="page-item" :class="{ disabled: data.current_page == 1 }">
                      <a class="page-link paginate" @click="page = 1">
                        <i class="fal fa-angle-double-left"></i>
                      </a>
                    </li>
                    <li class="page-item" :class="{ disabled: data.current_page == 1 }">
                      <a class="page-link paginate" @click="page = data.current_page - 1">
                        <i class="fal fa-angle-left"></i>
                      </a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == 1 }"
                      v-if="data.current_page > 2"
                    >
                      <a class="page-link paginate" @click="page = data.current_page - 2">{{
                        data.current_page - 2
                      }}</a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == 1 }"
                      v-if="data.current_page > 1"
                    >
                      <a class="page-link paginate" @click="page = data.current_page - 1">{{
                        data.current_page - 1
                      }}</a>
                    </li>
                    <li class="page-item selected">
                      <a class="page-link paginate">{{ data.current_page }}</a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == data.last_page }"
                      v-if="data.current_page < data.last_page"
                    >
                      <a class="page-link paginate" @click="page = data.current_page + 1">{{
                        data.current_page + 1
                      }}</a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page + 1 == data.last_page }"
                      v-if="data.current_page + 1 < data.last_page"
                    >
                      <a class="page-link paginate" @click="page = data.current_page + 2">{{
                        data.current_page + 2
                      }}</a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == data.last_page }"
                    >
                      <a class="page-link paginate" @click="page = data.current_page + 1">
                        <i class="fal fa-angle-right"></i>
                      </a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == data.last_page }"
                    >
                      <a class="page-link paginate" @click="page = data.last_page">
                        <i class="fal fa-angle-double-right"></i>
                      </a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
            <div class="pt-4"></div>
          </div>
        </div>
      </div>
      <transition name="fade" mode="out-in">
        <div
          class="m-quick-sidebar-overlay"
          v-if="showContractSave"
          @click="closeSaveContract()"
        ></div>
      </transition>
    </div>
  </div>
</template>

<script>
import CustomerContractModal from '@/components/contracts/CustomerContractModal';

import SelectProducts from '@/components/forms/SelectProducts';
import { returnMessageMixin } from '@/mixins/returnMessageMixin.js';
import SelectContractStatus from '@/components/forms/SelectContractStatus';

import { baseApiUrl } from '@/global';
import axios from 'axios';

export default {
  mixins: [returnMessageMixin],
  name: 'RepotyContractsAnalytical',
  props: ['start', 'finish'],
  components: { CustomerContractModal, SelectProducts, SelectContractStatus },
  data() {
    return {
      sortType: localStorage.customerContractsSortType
        ? localStorage.customerContractsSortType
        : 'id',
      sortReverse: localStorage.customerContractsSortReverse
        ? JSON.parse(localStorage.customerContractsSortReverse)
        : false,
      amount: localStorage.customerContractsDataAmount
        ? localStorage.customerContractsDataAmount
        : 100,
      page: localStorage.customerContractsDataPage ? localStorage.customerContractsDataPage : 1,
      filters: {
        id: localStorage.customerContractsFilterId ? localStorage.customerContractsFilterId : '',
        customer_id: localStorage.customerContractsFilterCustomer
          ? localStorage.customerContractsFilterCustomer
          : '',
        name: localStorage.customerContractsFilterName
          ? localStorage.customerContractsFilterName
          : '',
        document: localStorage.customerContractsFilterDocument
          ? localStorage.customerContractsFilterDocument
          : '',
        product: localStorage.customerContractsFilterProduct
          ? localStorage.customerContractsFilterProduct
          : '',
        percent: localStorage.customerContractsFilterPercent
          ? localStorage.customerContractsFilterPercent
          : '',
        birthday_month: localStorage.customerContractsFilterBirthdayMonth
          ? localStorage.customerContractsFilterBirthdayMonth
          : '',
      },
      billing_month: '',
      data: [],
    };
  },
  computed: {
    loading() {
      return !this.data.current_page;
    },
    showContractSave() {
      return this.$store.state.showContractSave;
    },
  },
  methods: {
    clearAlert() {
      this.alert = {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: '',
        reason: '',
      };
    },
    download() {
      const url = `${baseApiUrl}/v1/customer/contract/readjustment/download${this.convertFilters()}`;
      axios
        .get(url)
        .then((res) => {
          const arrData = res.data;

          let csvContent = 'data:text/csv;charset=utf-8,';
          csvContent += [
            Object.keys(arrData[0]).join(';'),
            ...arrData.map((item) => String(Object.values(item).join(';'))),
          ]
            .join('\n')
            .replace(/(^\[)|(\]$)/gm, '');

          const data = encodeURI(csvContent);
          const link = document.createElement('a');
          link.setAttribute('href', data);

          let fileName = `relatorio_contratos_reajustados`;

          if (this.billing_month) {
            fileName += `_${this.billing_month}`;
          }

          fileName = `${fileName}.csv`;
          link.setAttribute('download', fileName);

          link.click();
        })
        .catch((error) => {
          this.logMessageFailed(error.response);
        });
    },
    generate() {
      this.alert = {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: 'Gerando o relatório...',
        reason: '',
      };
      this.callData();
    },
    setFilter(filterToChange, id) {
      this.filters[filterToChange] = id;
    },
    clearFilters() {
      this.filters.contractId = '';
      this.filters.customer_id = '';
      this.filters.name = '';
      this.filters.document = '';
      this.filters.product = '';
      this.filters.percent = '';
      this.filters.birthday_month = '';
      this.sortType = 'id';
      this.sortReverse = false;
      this.callData();
    },
    setStorageFilters() {
      localStorage.setItem('customerContractsFilterId', this.filters.contractId);
      localStorage.setItem('customerContractsFilterCustomer', this.filters.customer_id);
      localStorage.setItem('customerContractsFilterName', this.filters.name);
      localStorage.setItem('customerContractsFilterDocument', this.filters.document);
      localStorage.setItem('customerContractsFilterProduct', this.filters.product);
      localStorage.setItem('customerContractsFilterPercent', this.filters.percent);
      localStorage.setItem('customerContractsFilterBirthdayMonth', this.filters.birthday_month);
      localStorage.setItem('customerContractsDataAmount', this.amount);
      localStorage.setItem('customerContractsDataPage', this.page);
      localStorage.setItem('customerContractsSortType', this.sortType);
      localStorage.setItem('customerContractsSortReverse', this.sortReverse);
    },
    convertFilters() {
      const filters = `?page=${this.page ? this.page : 1}&contract_id=${
        this.filters.contractId ? this.filters.contractId : ''
      }&customer_id=${this.filters.customer_id ? this.filters.customer_id : ''}
        &name=${this.filters.name ? this.filters.name : ''}&document=${
        this.filters.document ? this.filters.document : ''
      }&product=${this.filters.product ? this.filters.product : ''}&percent=${
        this.filters.percent ? this.filters.percent : ''
      }&birthday_month=${this.filters.birthday_month ? this.filters.birthday_month : ''}&month=${this.billing_month}&amount=${this.amount}&sortType=${this.sortType}&sortOrder=${
        this.sortReverse ? 'DESC' : 'ASC'
      }&start=${this.start}&end=${this.finish}`;

      return filters;
    },
    sortCall(sortType) {
      this.sortReverse = this.sortType == sortType ? !this.sortReverse : false;
      this.sortType = sortType;
    },
    callData() {
      this.data.current_page = 0;
      this.setStorageFilters();
      this.getDatas();
    },
    getDatas() {
      const url = `${baseApiUrl}/v1/customer/contract/readjustment/search/${this.convertFilters()}`;

      axios(url).then((res) => {
        this.data = res.data;

        this.$emit('updateLoading');
        if (res.data.current_page > res.data.last_page) {
          this.page = 1;
        }
      });
    },
  },
  watch: {
    amount() {
      if (this.page == 1) {
        this.callData();
      } else {
        this.page = 1;
      }
    },
    page() {
      this.callData();
    },
    sortType() {
      this.callData();
    },
    sortReverse() {
      this.callData();
    },
  },
  mounted() {
    window.scroll(0, 0);
  },
};
</script>

<style scoped>
.inputNumberFilter {
  width: 100px;
}

.inputTextFilter {
  width: 200px;
}
</style>
